import { useI18n } from "vue-i18n/index";
export class TranslationService {
  static translate(text: string) {
    const { t, te } = useI18n();
    if (te(text)) {
      return t(text);
    } else {
      return text.split(".").join(" ");
    }
  }
}
